import { GrcNotify, NotifyType } from '@grc/ui-package';
import { orderService } from '@grc/ui-shared/lib/components/common/constants/constants';
import { fetchShipmentByNumber } from '../../common/constants/url-constants';
import { IShipmentDetail } from '../../models/shipments/shipment-details.interface';
import notify from '../../common/notify';

export const GetShipmentDetails = async (
  fetchData: any,
  shipmentNumber: string
): Promise<IShipmentDetail | undefined> => {
  if (!shipmentNumber) return undefined;

  const url = fetchShipmentByNumber.replace('shipmentNumber', shipmentNumber);

  try {
    const response = await fetchData(url, notify, orderService);
    if (response?.status === 200) {
      return response.data as IShipmentDetail;
    }
    return undefined;
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};

export default GetShipmentDetails;
